import React, { Component } from 'react';
import { Alert, Button, Card, CardBody, CardGroup, Col, Container, Form, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';

import { connect } from "react-redux";

import { Loading } from '../../../views/Loading';

import { addCredentials, setAuthStatus } from '../../../store/actions/auth';

import logo from '../../../assets/img/brand/logo.png'

const mapStateToProps = state => {
  return { authStatus: state.authStatus };
};

const mapDispatchToProps = dispatch => {
  return {
    addCredentials: credentials => dispatch(addCredentials(credentials)),
    setAuthStatus: status => dispatch(setAuthStatus(status))
  };
};

class ConnectedLogin extends Component {

  constructor() {
    super();
    this.state = {
      screenStatus: 'READY',
      username: "",
      password: "",
      errorMessage: ""
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }

  handleSubmit(event) {
    this.setState({screenStatus: 'LOADING'});

    this._doLogin();
  }

  _doLogin() {
    fetch(process.env.REACT_APP_API_URL+"/auth/signin", {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'username': this.state.username,
        'password': this.state.password
      })
    })
    .then((response) => {
      if(response.status !== 200) {
        throw new Error("Something went wrong");
      }
      return response.json();
    })
    .then((responseJson) => {
      this.props.addCredentials({
        username: responseJson.username,
        token: responseJson.token
      });
      this.props.setAuthStatus("AUTHENTICATED");
    })
    .catch((error) => {
      this.setState({
        errorMessage: error.message,
        screenStatus: 'READY'
      })
    });
  }

  onDismiss() {
    this.setState({ errorMessage: "" });
  }

  render() {

    if (this.state.screenStatus === 'LOADING') {
      return (
        <LoginStructure>
          <Loading />
        </LoginStructure>
      );
    }

    return (
      <LoginStructure>
        <Alert color="danger" isOpen={!!this.state.errorMessage} toggle={() => this.onDismiss()}>
          {this.state.errorMessage}
        </Alert>
        <Form>
          <div className="mb-4">
            <img src={logo} width="100%" alt=""></img>
          </div>
          <p className="text-muted">Sign In to your account</p>
          <InputGroup className="mb-3">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="icon-user"></i>
              </InputGroupText>
            </InputGroupAddon>
            <Input onChange={(e) => this.handleChange(e)} type="text" placeholder="Username" autoComplete="username" id="username" value={this.state.username}/>
          </InputGroup>
          <InputGroup className="mb-4">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="icon-lock"></i>
              </InputGroupText>
            </InputGroupAddon>
            <Input onChange={(e) => this.handleChange(e)} type="password" placeholder="Password" autoComplete="current-password" id="password" value={this.state.password}/>
          </InputGroup>
          <Row>
            <Col xs="12">
              <Button onClick={(e) => this.handleSubmit(e)} color="primary" className="px-4 btn-block">Login</Button>
            </Col>
          </Row>
        </Form>
      </LoginStructure>
    );
  }
}

class LoginStructure extends Component {
  render() {
    return (
       <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="4">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                   {this.props.children}
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const Login = connect(mapStateToProps, mapDispatchToProps)(ConnectedLogin);

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js